export default __webpack_public_path__ + "static/media/img5.526781eb.png";